// PROMOTION px for styling
export const PROMOTION_COVER_HEIGHT = 150;
export const PROMOTION_TEXT_HEIGHT = 100;

export const PROMOTION_TOTAL_HEIGHT =
  PROMOTION_COVER_HEIGHT + PROMOTION_TEXT_HEIGHT;

export const PROMOTION_TOTAL_WIDTH = 320;

// PROMOTION types
export const FREE_SUBSCRIPTION = "FREE_SUBSCRIPTION";
export const PAID_SUBSCRIPTION = "PAID_SUBSCRIPTION";
export const AFFILIATE_URL = "AFFILIATE_URL";
